import angular from "angular";

export default class ListViewCtrl {

  constructor(dataSource, FilterService){
    this.FilterService = FilterService;
    this.dataSource = dataSource;
    this.filter = angular.copy(dataSource.filter);
    this.filterOptions = {};
    this.selection = {};
  }

  getEmptyFilter(){
    return {
    };
  }

  resetFilter(){
    this.filter = this.getEmptyFilter();
    this.load();
  }

  isFilterActive(){
    return Object.keys(this.getActiveFilter()).length > 0;
  }

  getActiveFilter(){
    const empty = this.getEmptyFilter();
    const filter = this.dataSource.filter;
    let activeFilter = {};
    Object.keys(filter).filter(key => filter[key] !== empty[key]).forEach(key => activeFilter[key] = filter[key]);
    return activeFilter;
  }

  load(){
    this.dataSource.filter = angular.extend({}, this.getEmptyFilter(), this.filter);
    if(this.FilterService) this.FilterService.setFilterToState(this.getActiveFilter());
    return this.dataSource.load();
  }

  selectedIds(){
    return Object.keys(this.selection).filter(k => this.selection[k]);
  }

  clearSelection(){
    this.selection = {};
    this.isAllSelected = false;
  }

  toggleSelection(){
    if(this.isAllSelected){
      this.clearSelection();
    }else{
      this.itemSource.result.map(item => item.id).forEach(id => this.selection[id] = true);
      this.isAllSelected = true;
    }
  }


}


// WEBPACK FOOTER //
// ./src/common/ListViewCtrl.js